module.exports = __webpack_public_path__ + "static/img/publicar768x1024.805ad0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/publicar/publicar768x1024.jpg
// module id = 7FCp
// module chunks = 47